import { RootState } from '../store';

export const getAuthState = (state: RootState) => state.auth;
export const selectLoading = (state: RootState) => state.auth.isLoading;
export const isLoggedIn = (state: RootState) => state.auth.isLoggedIn;
export const getUserType = (state: RootState) => state.auth.userType;
export const getRetailerId = (state: RootState) => state.auth.referer_id;
export const getRetailerSlug = (state: RootState) => state.auth.referer_slug;
